import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroBanner from './components/HeroBanner';
import PlatformGrid from './components/PlatformGrid';
import FeaturedArticles from './components/FeaturedArticles';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroBanner />
        <PlatformGrid />
        <StatsSection />
        <FeaturedArticles />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}